import React, { FC } from 'react'
import { Button, BUTTON_SIZE, BUTTON_TYPE, styled } from '~/app/components'
import { Typography } from '@yanolja-org/ya-com-core'

/**
 * InfiniteCouponRoom component
 * author: soojin.oh
 */

// type definitions
type Props = {
  onClick?: () => void
}

// styled components
const Container = styled.div`
  display: flex;
  border-radius: 0.8rem;
  border: solid 1px ${({ theme: { color } }) => color.gray200};
  background: ${({ theme: { color } }) => color.white};
  margin: 0 2rem;
  padding: 1.4rem 1.8rem 1.5rem 1.7rem;
  justify-content: space-between;

  & .sub-title {
    ${Typography('body2').regular}
    margin-bottom: .2rem;
    ${({ theme: { color } }) => color.gray600};
  }

  & .title {
    ${Typography('body1').bold}
    ${({ theme: { color } }) => color.gray900};
  }
`

// InfiniteCouponRoom component
const InfiniteCouponRoom: FC<Props> = function ({ onClick }) {
  return (
    <Container>
      <div>
        <div className="sub-title">무한 쿠폰룸</div>
        <div className="title">예약보상 쿠폰발급</div>
      </div>
      <Button
        title={'확인하기 >'}
        size={BUTTON_SIZE.M}
        type={BUTTON_TYPE.BLUE}
        style={{ border: 'none', marginRight: '-1rem' }}
        onClick={() => onClick?.()}
      />
    </Container>
  )
}

export default InfiniteCouponRoom
